// extracted by mini-css-extract-plugin
export default {"PopoverMenu":"UserButton_PopoverMenu__vNMwn","Button":"UserButton_Button__tz5Bs"};